import { render, staticRenderFns } from "./bill-item.vue?vue&type=template&id=c165d77c&lang=pug"
import script from "./bill-item.vue?vue&type=script&lang=js"
export * from "./bill-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports